export default "__VITE_ASSET__BLDyxj82__"